import { Modal } from "react-bootstrap";
import Collapsible from 'react-collapsible';
import React from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const basicSchema = Yup.object().shape({
    perm_name: Yup.string().required("Name name is required"),
    perm_description: Yup.string().required("Descriptio is required"),
});

const Edit = ({ showModal, hideModal, id, data }) => {
    const history = useNavigate();
    const onSubmit = async (values, actions) => {
        console.log(values);
        console.log(actions);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        editPermission(values);
    };

    const { values,
        errors,
        touched,
        isSubmitting,
        setFieldValue,
        handleBlur,
        handleChange,
        handleSubmit, submitForm } = useFormik({

            initialValues: {
                perm_name: data.perm_name,
                perm_description: data.perm_description,

            },
            validationSchema: basicSchema,
            onSubmit
        })


    const notifySuccess = () => toast.info('Permission info Updated.', {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const notifyError = () => toast.error('Something went wrong ...', {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const editPermission = async (e) => {
        try {
            const bodyFormData = new FormData();
            for (let value in values) {
                bodyFormData.append(value, values[value]);
                bodyFormData.append("id", id);
            }
            const response = await axios.post("/permission/" + id, bodyFormData);
            history("/permissions");
            hideModal();
            notifySuccess();
        } catch (error) {
            console.log(error.response)
            if (error.response) {
                notifyError();
            }
        }
    };


    return (


        <form onSubmit={handleSubmit} autoComplete="off" encType="multipart/form-data">


            <Modal
            style={{marginTop: "60px"}}
                show={showModal}
                onHide={hideModal}
                backdrop={false}
                contentClassName="custom-modal-style"
            >

                <Modal.Header closeButton>
                    <Modal.Title>Edit Permission</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div class="row" >
            <div class="col-md-6">
              <div class="card card-primary">

                <div class="card-body">
                  <div class="form-group">
                    <label for="inputName">Permission Name</label>
                    <input
                      type="text"
                      name="perm_name"
                      value={values.perm_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.perm_name && touched.perm_name ? "form-control input-error" : "form-control "}

                    />
                    {errors.perm_name && touched.perm_name && <p className="error">{errors.perm_name}</p>}

                  </div>

                  <div class="form-group">
                    <label for="inputName">Description</label>
                    <input
                      type="text"
                      name="perm_description"
                      value={values.perm_description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.perm_description && touched.perm_description ? "form-control input-error" : "form-control "}

                    />
                    {errors.perm_description && touched.perm_description && <p className="error">{errors.perm_description}</p>}

                  </div>

      

                </div>
              </div>
            </div>
         
          </div>

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-error" onClick={hideModal}>
                        Cancel
                    </button>

                    <button disabled={isSubmitting} onClick={submitForm} className="btn btn-success" type="submit">
                        Update
                    </button>

                </Modal.Footer>

            </Modal>
        </form>

    );
};

export default Edit;
